<div class="hd-cycle-hanging-gate-block" [style.--keynote-color]="color()">
  @if (faIcon()) {
    <i class="fas fa-{{ faIcon() }} hd-cycle-hanging-gate-block__icon" aria-hidden="true"></i>
  }
  <hd-cycle-gate-keynote-line
    [gate]="hanging().gate"
    [source]="hanging().encounter === 'renewal' ? 'both' : 'cycle'"
    [activations]="hanging().cycleActivations"
    [encounter]="hanging().encounter"
    (gateInfoRequested)="gateInfoRequested.emit($event)"
  />
  @if (expandable()) {
    <hd-cycle-cards-toggle [expanded]="expanded()" (toggle)="expandToggled.emit()" />
  }
</div>
